<template>
  <div>
    <navbar/>
    <container/>
  </div>
</template>

<script>
import Nav from "../../Nav";
import Container from "./DeclaracaoInssContainerGrafico"
export default {
  name: "DeclaracaoInssGrafico",
  components: {
    "navbar": Nav,
    "container": Container
  }
};
</script>


// WEBPACK FOOTER //
// src/components/pages/declaracao/DeclaracaoInssGrafico.vue